import { ref, get } from "firebase/database";
import React, { useEffect, useReducer } from "react";
import { RealDB } from "utils/config/firebase.config";
import useAuth from "utils/hooks/useAuth";
import { dbUser } from "utils/types/db";

export type userState = dbUser | null | undefined;

const authReducer = (state: userState, action: any) => {
  switch (action.type) {
    case "set":
      return action.payload;
    case "reset":
      return null;
  }
  return state;
};

export const userContext = React.createContext<userState>(null);

export const UserProvider = ({ children }: { children: JSX.Element }) => {
  const [userState, dispatch] = useReducer(authReducer, null);
  const auth = useAuth();
  userContext.displayName = "User Context";
  useEffect(() => {
    if (auth) init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);
  const init = async () => {
    try {
      const snapshot = await get(ref(RealDB, "/users/" + auth.uid));
      if (snapshot.exists()) {
        dispatch({ type: "set", payload: snapshot.val() });
      } else {
        throw Error("No data available");
      }
    } catch (error) {
      dispatch({ type: "reset" });
    }
  };
  return <userContext.Provider value={userState}>{children}</userContext.Provider>;
};

export default userContext;
